import { useContext } from 'react';
import { AppContext } from '../../context/Contexte';
const Share = ({ showGetter, setGetter }) => {
  const { t } = useContext(AppContext);
  const iframeHtml = `<script type="text/javascript">document.write('<iframe src="https://cbd-calculator.sowelab.com/" style="border:0;height:800px;width:600px"></iframe>');</script>`;
  const copyToClipboard = async (e) => {
    try {
      await navigator.clipboard.writeText(iframeHtml);
      e.target.setAttribute('disabled', 'disabled');
      setTimeout(() => {
        e.target.removeAttribute('disabled');
      }, 200);
    } catch (e) {}
  };
  if (inIframe()) return <></>;
  return (
    <>
      <div className="GetCBD">
        <a
          className="GetCBD-link"
          onClick={(e) => {
            e.preventDefault();
            setGetter(!showGetter);
          }}
          href=" "
        >
          {t('get_calculator_text')}
        </a>
      </div>
      {showGetter && (
        <div className="get-calculator">
          <textarea
            cols="30"
            rows="10"
            value={iframeHtml}
            readOnly={true}
          ></textarea>
          <button onClick={copyToClipboard} className="button btn__warning">
            {t('btn_copy_text')}
          </button>
        </div>
      )}
    </>
  );
};

export default Share;

export function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
